import { TradeRequestEventResourceListDTO } from './trade-request-event-resource-list.dto';
import { TradeRequestEventParticipantsListDTO } from './trade-request-event-participants-list.dto';

export class TradeRequestEventListDTO {

    id: string;

    type: number;

    title: string;

    description: string;

    location: string;

    start: string | Date;

    end: string | Date;

    participants: Array<TradeRequestEventParticipantsListDTO>;

    resources: Array<TradeRequestEventResourceListDTO>;

}
